import Request from './request'

const Rbac = {
  getAllRoles (callback) {
    Request.get('rbac/roles').then(callback).catch(this.bad_answer)
  },
  assignRoles (params, callback) {
    Request.post('rbac/assign', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  revokeRoles (params, callback) {
    Request.post('rbac/revoke', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getUserRoles (id, callback) {
    Request.get('rbac/user-roles/' + id).then(callback).catch(this.bad_answer)
  },
  getUsersRoles (params, callback) {
    Request.post('rbac/users-roles', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Rbac
